/**
 * Copyright 2025 Google LLC. This software is provided as-is, without warranty 
 * or representation for any use or purpose. Your use of it is subject to your 
 * agreement with Google.
 */
export const FEEDBACK_PLACEHOLDER = 'Provide additional feedback';
export const THUMBS_UP_OPTIONS = [
    { name: 'Correct', selected: false },
    { name: 'Easy to understand', selected: false },
    { name: 'Quick results', selected: false },
    { name: 'Latest evidence', selected: false }
];
export const THUMBS_DOWN_OPTIONS = [
    { name: 'Factually incorrect', selected: false },
    { name: 'Incomplete', selected: false },
    { name: 'Outdated', selected: false },
    { name: 'Irrelevant', selected: false }
];
export const FEEDBACK_ERROR_MSG = 'Unable to submit feedback at this time. Please try again later.'
export const ADDITIONAL_FEEDBACK_ERROR_MSG = 'Unable to submit additional feedback at this time. Please try again later.'
export const FUQ_ERROR_MSG = "Response suggestions are currently unavailable. You can still ask your own questions below.";
export const SORRY_CONTEXT =`I'm sorry, but there is currently no answer`